import axios from 'axios';
import { getRoutesQuery } from './queries';
import Split from '../split';
import { buildExpressQuery, buildLoopbackQuery } from './queries/builders';
import { renameKey } from '../../utils';

const getRoute = async (params) => {
    try {
        const useExpress = Split.getBooleanTreatment('use_express_migration_endpoints');
        const queryBuilder = useExpress ? buildExpressQuery : buildLoopbackQuery;
        const routeQuery = getRoutesQuery({ ...params, queryBuilder });

        const routeResp = await axios.get(routeQuery);
        const { data } = routeResp;
        if (useExpress && Array.isArray(data)) {
            data.forEach((item) => renameKey(item, '_id', 'id'));
        }
        return data;
    } catch (err) {
        return { err };
    }
};

export default getRoute;
